import React, {useEffect} from 'react';

export function useStickyState(defaultValue, key) {
  const [state, setState] = React.useState(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : defaultValue;
  });
  const [isReady, setIsReady] = React.useState(false);

  useEffect(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue !== null) {
      setState(JSON.parse(storedValue));
    }
    setIsReady(true);
  }, []);

  const updateState = (newValue) => {
    setState(newValue);
    localStorage.setItem(key, JSON.stringify(newValue));
  };

  return [state, updateState, isReady];
}
